var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"options":_vm.localeOptions,"disabled":_vm.disabled,"value-field":"code","text-field":"code"},on:{"input":_vm.updateValue},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})}
var staticRenderFns = []

export { render, staticRenderFns }